module.exports = __webpack_public_path__ + "static/media/E-sign.4004e1f4.svg";